import { PTTN_EMAIL } from "../constants/patterns"

const makeLink = (url) => {
  if (!url) return ''
  const isLink = /^https?:\/\//.test(url)
  if (isLink || url.startsWith('mailto:')) return url
  const isEmail = PTTN_EMAIL.test(url)
  if (isEmail) return `mailto:${url}`
  return /^\/[^/]/.test(url) ? `/${url}` : `//${url}`
}

export default makeLink
